var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-date',{attrs:{"options":_vm.options,"value":_vm.date,"locale":_vm.locale},on:{"input":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }